import { EnumeratorsApiService } from '../../common/services/enumerators.api.service';

export default {
  namespaced: true,

  state: {
    enumsStatus: 'loading',
    enums: null,
  },

  getters: {
    getEnums: state => state.enums,
    getEnumsStatus: state => state.enumsStatus,
  },

  mutations: {
    FETCH_ENUMS_REQUEST: state => {
      state.enumsStatus = 'loading';
    },
    FETCH_ENUMS_SUCCESS: state => {
      state.status = 'success';
    },
    FETCH_ENUMS_FAIL: state => {
      state.status = 'fail';
    },
    SET_ENUMS(state, enums) {
      state.enums = enums;
    },
  },

  actions: {
    async fetchOrderCreditStateEnumerators({ commit, dispatch }) {
      commit('FETCH_ENUMS_REQUEST');

      try {
        const response = await EnumeratorsApiService.get(builder => {
          builder.with('order_credit_state');
        });

        const enums = response.getItem();

        commit('SET_ENUMS', enums);
        commit('FETCH_ENUMS_SUCCESS');
      } catch (e) {
        dispatch('handleError', e);
      }
    },

    // TODO: refactor error handling
    handleError({ commit }, error) {
      commit('FETCH_ENUMS_FAIL');
      const message = error.getFirstValidationErrorMessage() || error.getMessage();
      this.$app.$alertError(message);
    },
  },
};
